export const EDIT_ADDRESS_FIELDS = 'editAddresss';
export const EDIT_DESCRIPTION = 'editDescription';
export const EDIT_EMAIL_ADDRESSES = 'editEmailAddresses';
export const EDIT_PHONE_NUMBERS = 'editPhoneNumbers';

// For Groups Profile
export const EDIT_PHONE_NUMBERS_GROUP = 'editPhoneNumbersGroup';
export const EDIT_EMAIL_ADDRESSES_GROUP = 'editEmailAddressesGroup';
export const EDIT_ADDRESS_FIELDS_GROUP = 'editAddressesGroup';
